import axios from 'axios';
import { apiConfig } from '../config/apiConfig';

const api = axios.create({
  baseURL: apiConfig.baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to attach token to all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for global error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      if (status === 401 || status === 403) {
        // Session expired or forced logout
        localStorage.clear();
        if (typeof window !== 'undefined' && window.showSessionExpiredModal) window.showSessionExpiredModal();
        return;
      }
      if (status === 404) {
        if (typeof window !== 'undefined' && window.showUnavailableModal) window.showUnavailableModal();
        return;
      }
    } else if (error.request) {
      // Network error or backend unreachable
      if (typeof window !== 'undefined' && window.showUnavailableModal) window.showUnavailableModal();
      return;
    }
    return Promise.reject(error);
  }
);

export default api;